__turbopack_context__.v({
  "blinkTwice": "project-detail-module-scss-module__vQhP-W__blinkTwice",
  "category": "project-detail-module-scss-module__vQhP-W__category",
  "collapseWindow": "project-detail-module-scss-module__vQhP-W__collapseWindow",
  "darken": "project-detail-module-scss-module__vQhP-W__darken",
  "expandFromTopLeft": "project-detail-module-scss-module__vQhP-W__expandFromTopLeft",
  "expandWindow": "project-detail-module-scss-module__vQhP-W__expandWindow",
  "first-column": "project-detail-module-scss-module__vQhP-W__first-column",
  "project-info": "project-detail-module-scss-module__vQhP-W__project-info",
  "project-info-content": "project-detail-module-scss-module__vQhP-W__project-info-content",
  "second-column": "project-detail-module-scss-module__vQhP-W__second-column",
  "shrinkToTopLeft": "project-detail-module-scss-module__vQhP-W__shrinkToTopLeft",
  "title": "project-detail-module-scss-module__vQhP-W__title",
  "top-section": "project-detail-module-scss-module__vQhP-W__top-section",
});
